<template>
  <j-modal :title="title" v-dragModal :width="800" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="disableSubmit">
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-model-item :label="$t('用户反馈')">
                <a-textarea v-model="model.userFeedback" :placeholder="$t('请输入用户反馈')" :rows="4" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
  import JUpload from '@/components/jeecg/JUpload'
  export default {
    name: 'modal',
    components: {
      JUpload
    },
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {},
        validatorRules: {},
        url: {
          queryById: "/jeecg-charge/oa/userComplaints/queryById",
        },
      }
    },
    methods: {
      init(row){
        this.visible = true;
        this.title = this.$t('评价');
        this.disableSubmit = true;
        this.model = JSON.parse(JSON.stringify(row));
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleCancel() {
        this.close()
      },
      handleOk() {
        // 评价提交逻辑(暂未实现)
        this.close()
      },
    }
  }
</script>